/** biome-ignore-all lint/suspicious/noTemplateCurlyInString: Expected */
export const Norwegian = {
  BASE: {
    DIALOG_HEADER: {
      BACK: "Tilbake",
      CLOSE: "Lukk",
      REFRESH: "Oppdater",
    },
    DROPDOWN: {
      ALL_ITEMS_SELECTED: "Alle elementer er valgt.",
      CLEAR_SEARCH: "Tøm søk",
      CLEAR: "Tøm",
      NO_OPTIONS: "Ingen alternativer",
      SEARCH: "Søk",
      SELECT_ALL: "Velg alle",
      DESELECT_ALL: "Fjern alle valg",
      CLEAR_ALL: "Tøm alle",
      EXPAND: "Utvid",
      COLLAPSE: "Skjul",
    },
  },
  SEARCH: "Søk",
  CLEAR_SEARCH: "Tøm søk",
  ACCOUNT_VERIFICATION_ERROR: {
    SKIP: "Hopp over",
    VERIFY_EMAIL: "Verifiser e-postadressen din",
    WE_NOTICED:
      "Vi har lagt merke til at du må verifisere e-postadressen din. For å gjøre dette, klikk på knappen nedenfor.",
    WITHOUT_VERIFICATION:
      "Uten verifisering vil du ikke kunne få tilgang til Hoylu-arbeidsområder.",
  },
  APP: {
    LOADING_YOUR_WORKSPACE: "Laster inn arbeidsområdene dine",
    READ_ONLY: "Skrivebeskyttet",
  },
  ASSET_PANEL: {
    USE_EXPANDED_VIEW: "Bruk utvidet visning",
    USE_COMPACT_VIEW: "Bruk kompakt visning",
  },
  BETA_DISABLED_CONTENT: {
    BETA_PERIOD_ENDED: "Betaperioden er avsluttet.",
    TAKE_ME: "Ta meg til Hoylu",
    THANK_YOU: "Takk for din interesse i Hoylu-betaen.",
  },
  CENTERED_CONTENT_WITH_LOGO: {
    HOYLU_LOGO: "Hoylu-logo",
    LEFT_PATH_ICON: "Sti-ikon til venstre",
    RIGHT_PATH_ICON: "Sti-ikon til høyre",
  },
  ANALYTICS: {
    TITLE: "Tittel",
    DESCRIPTION: "Beskrivelse",
    TEAM: "Team",
    WEEK: "Startuke",
    START_DATE: "Startdato",
    END_DATE: "Sluttdato",
    STATUS: "Status",
    LABELS: "Etiketter",
    WORKSPACES: "Arbeidsområder",
    NO_TEAM: "Ingen team tildelt",
    TASK_LIST: "Oppgaveliste ($0)",
    TASK_COUNT: "${0} av ${1}",
    DATE_FROM: "Dato fra",
    DATE_TO: "Dato til",
    REFRESH: "Oppdater",
    TASKS: "Oppgaver",
    TOTAL: "Totalt",
    PERCENT_COMPLETE: "Prosent fullført",
    COUNT: "Antall",
    NO_DATA: "Ingen data",
    LOAD_ERROR: "Feil ved lasting av data",
    LOCATIONS_TOOLTIP: "Vis liste over arbeidsområder elementet befinner seg i",
    LOCATIONS_LIST: "Arbeidsområdeliste",
  },
  CHANGE_MASTER_DIALOG: {
    TITLE: "Koble mal til nytt hovedarbeidsområde",
    SUBTITLE:
      "Angi ny arbeidsområde-ID eller lim inn lenke til nytt hovedområde:",
    CANCEL: "Avbryt",
    CHANGE_MASTER: "Endre hoved",
  },
  CLOSE_BUTTON: {
    CLOSE: "Lukk",
  },
  CONFIRMATION_DIALOG: {
    CANCEL: "Avbryt",
    OPTION_ICON: "alternativ-ikon",
    PASSWORD: "Passord",
  },
  CONFIRMATION_DRAWER_CONTENT: {
    CANCEL: "Avbryt",
    OPTION_ICON: "alternativ-ikon",
    PASSWORD: "Passord",
  },
  DELETE_SCOPE_DIALOG: {
    TITLE: "Slett alle prosjektdata permanent",
    MESSAGE:
      "Denne handlingen vil <strong>slette alle oppgavedata for dette prosjektet permanent.</strong>\n" +
      "Arbeidsområder bygget på dette prosjektet vil miste dataene sine som et resultat.\n" +
      "Denne handlingen kan ikke angres.\n",
    CONFIRM_PROJECT_NAME: "Bekreft prosjektnavn",
    CONFIRM_DELETE:
      "Jeg bekrefter at jeg vil slette dataene til dette prosjektet permanent",
    BUTTON_TEXT: "Slett alle data",
  },
  COPY_EMAIL_LINK: {
    COPIED_LINK: "Lenke kopiert",
    COPY_LINK: "Kopier lenke",
    COPY_WORKSPACE_LINK: "Kopier arbeidsområdelenke",
    EMAIL: "Send lenke på e-post",
    EMAIL_WORKSPACE_LINK: "Send arbeidsområdelenke på e-post",
    LEARN_MORE:
      "For å lære mer om Hoylu og opprette en konto, vennligst besøk Hoylu.com.",
    SMALL_COPIED_LINK: "Kopiert",
    SMALL_COPY_LINK: "Kopier",
    SMALL_EMAIL: "E-post",
    WORKSPACE_SHARED_WITH_YOU: "Et Hoylu-arbeidsområde har blitt delt med deg.",
  },
  CREATE_WORKSPACES_SECTION: {
    CREATE: "Opprett",
    CREATE_WORKSPACE: "Opprett arbeidsområde",
    FROM_TEMPLATE: "Fra mal",
    MODULES: {
      BLANK_WORKSPACE: "Tomt arbeidsområde",
      BUSINESS_MODEL_CANVAS: "Business Model Canvas",
      KANBAN: "Kanban",
      PI_PLANNING: "PI-planlegging",
      PULL_PLANNING: "Pull-planlegging",
      AGILE_PLANNING: "Agil planlegging",
      RETROSPECTIVE: "Retrospektiv",
      SIMPLE_DRAWING: "Enkel tegning",
      SUPPLY_CHAIN: "Forsyningskjede",
      SWOT_ANALYSIS: "SWOT-analyse",
      VALUE_PROPOSITION_CANVAS: "Value Proposition Canvas",
      WEEKLY_PLANNER: "Ukeplanlegger",
      WORKSPACE_IDEAS: "Arbeidsområdeideer",
    },
    OPEN: "Åpne",
    TOOLTIPPOSTFIX: "\n*Hoylu Enterprise-funksjon",
    TOGGLE_SHOW_ALL: "vis/skjul alle arbeidsområder",
    UPSELL: {
      AVAILABLE_WITH_ENTERPRISE:
        "Denne modulen er tilgjengelig med Enterprise-planen",
      CONTACT_US: "Kontakt oss",
      NEED_MORE_WORKSPACES: "Trenger du flere arbeidsområder?",
      REACHED_LIMIT:
        "Du har nådd grensen for gratis arbeidsområder. Oppgrader til Hoylu Plus eller kontakt prosjektadministratoren for å bli lagt til som bidragsyter i et prosjekt for å låse opp ubegrensede arbeidsområder, full deling og mye mer.\n",
      UPGRADE_TO_ENTERPRISE:
        "For å prøve det, oppgrader planen din til en Enterprise-konto, eller kontakt oss for en demonstrasjon og for å lære mer.",
      UPGRADE_TO_PLUS: "Oppgrader til Plus-planen",
      AVAILABLE_WITH_PLUS: "Denne funksjonen er tilgjengelig med Plus-planen",
      UNLOCK_WITH_PLUS:
        "Oppgrader til Hoylu Plus og lås opp ubegrensede arbeidsområder, full deling og mye mer.",
    },
    VIEW_LESS: "vis mindre",
    VIEW_MORE: "vis mer",
  },
  DELETE_WORKSPACE_DIALOG: {
    CONFIRM_DELETE: "Ja, slett dette arbeidsområdet permanent",
    DELETE: 'Slett "${0}"',
    WARNING:
      "Er du sikker på at du vil slette ${0}? Arbeidsområdet vil bli fjernet fra Hoylu umiddelbart. Dette kan ikke angres.",
  },
  INFO_SECTION_REMOVE_WORKSPACE_DIALOG: {
    HIDE_WORKSPACE:
      "Skjul arbeidsområde (vil forbli på dashboard som skjult arbeidsområde)",
    LEAVE_WORKSPACE:
      "Forlat arbeidsområde (vil ikke lenger være tilgjengelig på dashboard ditt)",
    DELETE_WORKSPACE:
      "Slett arbeidsområde (Sletter arbeidsområdet permanent for ALLE brukere)",
    HIDE: "Skjul arbeidsområde",
    LEAVE: "Forlat arbeidsområde",
    DELETE: "Slett arbeidsområde",
    CANCEL: "Avbryt",
    TITLE: "Fjern arbeidsområde",
  },
  DELETE_TEMPLATE_DIALOG: {
    TITLE: "Fjern mal",
    SUBTITLE:
      "Malen vil ikke lenger være tilgjengelig i malpanelet. \n" +
      "Det tilkoblede hovedarbeidsområdet vil bli et vanlig arbeidsområde igjen.",
    CANCEL: "Avbryt",
    CONTINUE: "Fortsett",
  },
  DELETE_WORKSPACE_DRAWER: {
    CONFIRM_DELETE: "Ja, slett dette arbeidsområdet permanent",
    DELETE: 'Slett "${0}"',
    WARNING:
      "Er du sikker på at du vil slette ${0}? Arbeidsområdet vil bli fjernet fra Hoylu umiddelbart. Dette kan ikke angres.",
  },
  DUPLICATE_WORKSPACE_DIALOG: {
    CANCEL: "Avbryt",
    COPY_OF: "Kopi av",
    COPY_THIS_WORKSPACE: "Kopier dette arbeidsområdet",
    DUPLICATE: "Dupliser",
    MAKE_COPY: "Lag en kopi av",
    NEW_WORKSPACE_NAME: "Nytt arbeidsområdenavn",
    OPTION_ICON: "alternativ-ikon",
    PASSWORD: "Passord",
    CHARACTERS: "minst 8 tegn",
    PRIVATE_WORKSPACE: 'Sett lenkedeling tillatelse til "ingen tilgang"',
    PRIVATE_WORKSPACE_TOOLTIP:
      "Arbeidsområdet er satt til privat uten tilgang via arbeidsområdelenke.\n" +
      'Dette kan senere endres i "del"-innstillingene for arbeidsområdet.',
    SHOW_PASSWORD: "vis passord",
    NEW_PASSWORD: "Nytt arbeidsområdepassord",
  },
  EDIT_LABEL_DIALOG: {
    LABELS: "Etiketter",
    ENTER_LABEL: "Angi etikett",
    ADD: "Legg til",
    REMOVE: "Fjern",
    LOADING: "Laster",
  },
  ERROR: {
    CANNOT_APPLY_CHANGES:
      "Vi kan ikke bruke endringene dine på arbeidsområdet for øyeblikket. Vennligst prøv igjen senere.",
    CANNOT_CREATE_WORKSPACE:
      "Vi kan ikke opprette et arbeidsområde for øyeblikket. Vennligst prøv igjen senere.",
    CANNOT_DELETE_WORKSPACE:
      "Vi kan ikke slette dette arbeidsområdet. Vennligst prøv igjen senere.",
    CANNOT_DUPLICATE_WORKSPACE:
      "Vi kan ikke duplisere dette arbeidsområdet for øyeblikket. Vennligst prøv igjen senere.",
    CANNOT_HIDE_WORKSPACE:
      "Vi kan ikke skjule dette arbeidsområdet. Vennligst prøv igjen senere.",
    CANNOT_UNHIDE_WORKSPACE:
      "Vi kan ikke vise dette arbeidsområdet. Vennligst prøv igjen senere.",
    CANNOT_REMOVE_PASSWORD:
      "Vi kan ikke fjerne passordet for dette arbeidsområdet. Vennligst prøv igjen senere.",
    CANNOT_SET_PASSWORD:
      "Vi kan ikke angi passord for dette arbeidsområdet. Vennligst prøv igjen senere.",
    FAILED_DETECT_TEAMS: "kunne ikke angi teaminnstillinger",
    INCORRECT_PASSWORD: "Feil passord. Vennligst prøv igjen.",
    INCORRECT_WORKSPACE_PASSWORD:
      "Feil arbeidsområdepassord. Vennligst prøv igjen.",
    SOMETHING_WENT_WRONG: "Noe gikk galt, våre ingeniører jobber med det!",
    VERIFY_WORKSPACE_ID:
      "Vennligst verifiser arbeidsområde-ID og at du har tillatelse til å åpne dette arbeidsområdet.",
    WORKSPACE_DELETED: "arbeidsområde slettet",
    WORKSPACE_HAS_BEEN_DELETED:
      "Arbeidsområdet du søker etter har blitt slettet. Prøv å søke etter et annet arbeidsområde",
    PROJECTS: {
      INSUFFICIENT_PERMISSIONS_TO_REMOVE_WORKSPACE:
        "Kan ikke fjerne dette arbeidsområdet fra prosjektet. Utilstrekkelige tillatelser. Kontakt prosjektadministrator.",
      INSUFFICIENT_PERMISSIONS_TO_ADD_WORKSPACE:
        "Kan ikke tildele dette arbeidsområdet til prosjektet. Utilstrekkelige tillatelser. Kontakt prosjektadministrator.",
      CANNOT_ADD_WORKSPACE:
        "Kan ikke tildele dette arbeidsområdet til prosjektet. Årsak:",
      REASON_MAX_WORKSPACES:
        "Maks arbeidsområdegrense er nådd for dette prosjektet",
    },
  },
  ERROR_DIALOG: {
    OK: "Ok",
  },
  ERROR_FETCHING_WORKSPACE: {
    ERROR_FETCHING_WORKSPACES: "Feil ved henting av arbeidsområder",
    TRY_AGAIN: "Prøv igjen",
  },
  LOAD_MORE_WORKSPACES: {
    LOAD_MORE: "Last flere",
  },
  FILTER_BY_NAME: {
    FILTER_BY_NAME: "Filtrer etter navn",
    SEARCH: "Søk",
    SELECT_PROJECT: "Velg prosjekt",
    LOADING_WORKSPACES: "Laster",
    MAGNIFYING_GLASS: "forstørrelsesglass",
    DASHBOARD: "Dashboard",
    WORKSPACES: "Arbeidsområder",
    PROJECT_SETTINGS: "Prosjektinnstillinger",
    PROJECT_SETTINGS_LABEL: "Åpne prosjektinnstillinger...",
    NEW_PROJECT: "Nytt prosjekt",
    INACTIVE: "INAKTIV",
  },
  FILTER_BY_WORKSPACE_LABEL: {
    FILTER_BY_LABELS: "Filtrer etter etiketter",
    LOADING_WORKSPACES: "Laster",
    FILTER: "Filter",
    APPLY: "Bruk",
    INCLUDE_HIDDEN_WORKSPACES: "Vis skjulte arbeidsområder",
  },
  HIDE_WORKSPACE_DIALOG: {
    HIDE: "Skjul",
    WARNING: "Dette arbeidsområdet vil bli skjult fra dashboard ditt",
  },
  LEAVE_WORKSPACE_DIALOG: {
    LEAVE: "Forlat",
    WARNING:
      "Arbeidsområdet vil bli fjernet fra dashboard og vil ikke lenger telle mot kredittgrensen.\n" +
      "Hvis lagt til, vil du også bli fjernet fra arbeidsområdets tillatelsesliste.",
  },
  HIDE_WORKSPACE_DRAWER: {
    HIDE: "Skjul",
    WARNING: "Dette arbeidsområdet vil bli skjult fra dashboard ditt",
  },
  HOYLU_LOGO: {
    HOYLU_DASHBOARD: "Hoylu-dashboard",
    HOYLU_LOGO: "Hoylu-logo",
  },
  KANBAN_CONFIGURATION: {
    SET_COLUMNS: "Angi antall kolonner",
  },
  LINKED_MASTER_DIALOG: {
    TITLE: "Tilkoblet hovedarbeidsområde",
    SUBTITLE: "Malen er for øyeblikket koblet til:",
    NAME_FIELD: "Arbeidsområdenavn:",
    ID_FIELD: "Arbeidsområde-ID:",
    CANCEL: "Avbryt",
    CHANGE_MASTER: "Endre hoved",
    EDIT_CONTENT: "Rediger innhold",
  },
  LOGIN_PROMPT: {
    AGREE: "Jeg godtar Hoylus",
    BACK_TO_LOGIN: "Tilbake til pålogging",
    ENTER_AS_GUEST: "Logg inn som gjest",
    ENTER_EMAIL: "Angi e-post",
    JOIN: "Bli med",
    LOGIN: "Logg inn",
    OR: "eller",
    SIGN_UP: "Registrer deg",
    TERMS: "Vilkår for bruk",
    WELCOME_TO_HOYLU: "Velkommen til Hoylu",
  },
  LOADING_WORKSPACE_DIALOG: {
    LOADING_WORKSPACE: "Laster arbeidsområde",
    LOADED: "lastet",
    PROCESS: "behandlet",
    RENDER: "gjengitt",
    STEP: "Trinn ${0}/${1}",
  },
  MAC_APP: {
    UPSELL_TITLE: "Trenger du flere arbeidsområder?",
    UPSELL_TEXT:
      "Du har nådd grensen for tilgjengelige arbeidsområder. Vennligst besøk Hoylu.com eller snakk med administratoren for flere arbeidsområder.",
    UPSELL_BUTTON: "Hoylu.com",
  },
  NEW_WORKSPACE_DIALOG: {
    CHARACTERS: "minst 8 tegn",
    CONTINUE: "Fortsett",
    CREATE_WORKSPACE: "Opprett arbeidsområde",
    PASSWORD: "Passord",
    SHOW_PASSWORD: "vis passord",
    NEW_PASSWORD: "Nytt arbeidsområdepassord",
  },
  NOTIFICATIONS: {
    TITLE: "Varsler",
    NAVIGATE_TO_ELEMENT: "Naviger til element",
    CLOSE_BUTTON: "Lukk",
    SHOW_ALL_MESSAGES: "Vis alle meldinger",
    HIDE_READ: "Skjul leste",
    MARK_ALL_AS_READ: "Merk alle varsler som lest",
    NOTIFICATION_BADGE: "Varselmerke",
    SUBSCRIBE:
      "Klikk her for å bli informert om endringer med varsler i appen.\nCtrl + klikk her for å bli informert i appen og via sammendragsmail.",
    UNSUBSCRIBE:
      "Klikk her for å stoppe mottak av varsler for dette elementet.",
    NO_MORE_MESSAGES: "Ingen flere meldinger",
  },
  ORG_BANNER: {
    ORGANIZATION_BANNER: "Organisasjonsbanner",
  },
  CREDIT_LIMIT_WARNING_BANNER: {
    TITLE: "Du er over grensen for gratiskonto.",
    ADD_TO_PROJECT: "legg til i prosjekt...",
    BUTTON: "Oppgrader",
  },
  ORG_BLOCKED_CREATE_DIALOG: {
    TITLE: "Kan ikke opprette arbeidsområde",
    TEXT: "Organisasjonen din har aktivert policyen om at kun administratorer kan opprette arbeidsområder. Vennligst kontakt en organisasjonsadministrator som administrerer Hoylu-tilgang for flere detaljer.",
  },
  CREDIT_LIMIT_REACHED_DIALOG: {
    TITLE: "Du er over grensen for gratiskonto.",
    BUTTON_TEXT: "Oppgrader",
  },
  TEXT_INPUT: {
    CLEAR: "Tøm",
    TOGGLE_PASSWORD_VISIBILITY: "Vis/skjul passord",
  },
  PERMISSION_BAR: {
    ACCESS: "tilgang",
    ANYONE_WITH_LINK_IN_ORG: "Alle i organisasjonen min med denne lenken",
    AUTHENTICATED_ACCOUNTS_READ_ONLY_ACCESS:
      "Autentiserte kontoer som er utenfor organisasjonen vil ha skrivebeskyttet tilgang til arbeidsområdene.\n" +
      "Gjest (uautentisert) skrivebeskyttet tilgang til arbeidsområder er også aktivert.",
    AUTHENTICATED_ACCOUNTS_NO_ACCESS:
      "Autentiserte kontoer som er utenfor organisasjonen vil ikke ha tilgang til organisasjonens arbeidsområder.\n" +
      "Det er ingen gjest (uautentisert) tilgang til organisasjonens arbeidsområder.",
    HAS: "har",
    ONLY_ADMINS_CHANGE_ACCESS:
      "Kun arbeidsområdeadministratorer kan endre tilgangstillatelser",
    ONLY_PROJECT_ADMINS_CHANGE_ACCESS:
      "Kun prosjektadministratorer kan endre tilgangstillatelser",
    REMOVE_USER: "Fjern bruker",
    REMOVE_WORKSPACE_ACCESS: "Fjern bruker fra arbeidsområdet",
    REMOVE_PROJECT_WORKSPACE_ACCESS: "Tilbakestill tilgang",
  },
  PI_CONFIGURATION: {
    SET_ITERATIONS: "Angi antall iterasjoner",
  },
  INVITE_USERS: {
    INVITE_USER: "Inviter brukere",
    INVITE_USERS_HEADER: "Inviter til Hoylu",
    INVITE_USERS_DESCRIPTION:
      "Angi e-postadressene til personene du vil invitere til å bli med i Hoylu.\nInvitasjoner vil kun sendes til e-postadresser uten en Hoylu-konto.",
    INVITE: "Inviter",
    CANCEL: "Avbryt",
    ERR: "Ugyldig e-post oppdaget",
    ERR_QTY: "Du kan sende opptil 10 e-poster om gangen",
    HINT: "Du kan invitere flere personer ved å angi flere e-postadresser separert med mellomrom",
  },
  SHARED_WORKSPACE: {
    ENTER_ID: "Angi arbeidsområde-ID eller lim inn lenke",
    MAGNIFYING_GLASS: "forstørrelsesglass",
    OPEN: "Åpne",
    OPEN_SHARED_WORKSPACE: "Åpne delt arbeidsområde",
  },
  SHARE_TYPE: {
    ADMIN: "admin",
    EDIT: "rediger",
    NO_ACCESS: "ingen",
    READ: "les",
    REMOVE: "fjern",
    ADMIN_TOOLTIP:
      "Brukeren har full tilgang til konfigurering og redigering av arbeidsområdet.",
    EDIT_TOOLTIP:
      "Brukeren kan redigere innhold, men har begrenset mulighet til å konfigurere arbeidsområdet.",
    READ_TOOLTIP:
      "Brukeren kan kun se arbeidsområdets innhold, men innstillinger for lenkedeling kan overstyre denne begrensningen.",
    NO_ACCESS_TOOLTIP:
      "Brukeren har ingen tilgang til arbeidsområdet men innstillinger for lenkedeling kan overstyre denne begrensningen.",
    LINK: {
      EDIT_TOOLTIP:
        "Alle med tilgang til arbeidsområdet kan redigere innholdet.",
      READ_TOOLTIP: "Alle med tilgang til arbeidsområdet kan lese innholdet.",
      NO_ACCESS_TOOLTIP:
        "Kun brukere med eksplisitte tillatelser kan få tilgang til arbeidsområdet.",
    },
  },
  SHARE_WORKSPACE_DIALOG: {
    ANYONE_WITH_LINK: "Alle med denne lenken",
    LINK_SHARING: "Lenkedeling",
    PERMISSIONS_SECTION: {
      TITLE_PROJECT_WORKSPACE: "Tilgang til prosjektarbeidsområde",
      TITLE: "Tilgang til arbeidsområde",
    },
    WORKSPACE_INFO: "Tittel: ${0}",
    CHANGE_THUMBNAIL: "Endre miniatyrbilde",
    SHARE_THIS_WORKSPACE: "Del dette arbeidsområdet: ${0}",
    REMOVE_WORKSPACE: "Fjern arbeidsområde",
    REMOVE_TEMPLATE: "Fjern mal",
    REMOVE_FROM_PROJECT: "Fjern fra prosjekt",
    MANDATORY_FIELD: "Dette feltet er påkrevd",
    CHARACTER_LIMIT: "Tittelen er for lang",
    WORKSPACE_TITLE: "Arbeidsområdetittel",
    TEMPLATE_TITLE: "Maltittel",
    TEMPLATE_DESCRIPTION_TITLE: "Malbeskrivelse",
    TEMPLATE_DESCRIPTION_PLACEHOLDER: "Legg til beskrivelse her",
    TEMPLATE_CATEGORY_TITLE: "Publiser i kategorier",
    TEMPLATE_CATEGORY_PLACEHOLDER: "Kategori",
    TEMPLATE_INFO: "Malinformasjon",
    LINKED_MASTER: "Tilkoblet hoved",
    SAVE: "Lagre",
    PUBLISH_AS_TEMPLATE: "Publiser som mal",
    PUBLISH_AS_TEMPLATE_NOT_ALLOWED:
      "Dette arbeidsområdet er koblet til en annen organisasjon og kan ikke publiseres.\n" +
      "For å publisere dette arbeidsområdet som en mal, vennligst dupliser det og publiser deretter duplikatet.",
    PUBLISH: "Publiser",
    PROJECT: "Prosjekt",
    CANCEL: "Avbryt",
    EDIT: "Rediger",
    SAVED: "LAGRET!",
    SAVING: "LAGRER...",
    PUBLIC_SHARING: {
      TITLE: "Offentlig deling & standardtilgang",
      NON_MEMBERS: "Ikke-medlemmer legges til i prosjektet...",
      SHARE_TYPE: {
        EDIT: "som Bidragsytere",
        READ: "som Seere",
      },
      CHANGE_SUCCESS: "Oppdatert tilgang til arbeidsområde.",
      TOOLTIP: {
        TITLE: "Hvis du krysser av for dette flagget, vil",
        ITEM_1:
          "gjør arbeidsområdet synlig for prosjektmedlemmer i prosjektmappen",
        ITEM_2:
          "gjør arbeidsområdet tilgjengelig for ikke-prosjektmedlemmer med lenken",
        ITEM_3:
          "legg automatisk til ikke-medlemmer i prosjektet som seere / bidragsytere",
      },
    },
  },
  SEARCH_WORKSPACE_DIALOG: {
    TITLE: "Søk i arbeidsområder",
    LABEL: "Etikett",
    CANCEL: "Avbryt",
    SEARCH: "Søk",
    LOADING_WORKSPACES: "Laster",
  },
  ASSIGN_PROJECT_DIALOG: {
    ASSIGN_TO_PROJECT: "Tildel til prosjekt",
    ASSIGN_PROJECT_DESCRIPTION:
      "Å tildele et arbeidsområde til et prosjekt vil gjøre at dette arbeidsområdet vises på dashboard til alle kvalifiserte prosjektdeltakere.",
    SELECT_A_PROJECT: "Velg et prosjekt",
  },
  REMOVE_WORKSPACE_FROM_PROJECT_DIALOG: {
    TITLE: "Fjern ${0} fra prosjekt",
    MESSAGE: "Er du sikker på at du vil fjerne ${0} fra dette prosjektet?",
    BUTTON: "Fjern",
  },
  SHARING_ICONS: {
    COLLAPSE: "Skjul",
    EXPAND: "Utvid",
    LOCKED: "Låst",
    PERMISSIONS: "Tillatelser",
    UNLOCKED: "Ulåst",
    USERS: "Brukere",
  },
  TEMPLATE_CARD: {
    TILE_IMAGE: "Flisbilde",
  },
  USER_PROFILE_DRAWER: {
    HOYLU_LOGO: "Hoylu-logo",
    LOGOUT: "Logg ut",
  },
  USER_PROFILE_WIDGET: {
    USER_MARBLE: "Brukermarble",
    LOGOUT: "Logg ut",
    INVITE_USER: "Inviter brukere",
    MANAGEMENT_PORTAL: "Administrasjonsportal",
    SWITCH_COLOR_SCHEME: "Bytt fargeskjema",
    THEME_LIGHT_TITLE: "Lys",
    THEME_DARK_TITLE: "Mørk",
    UPLOAD: "Last opp",
    MANAGE_ACCOUNT: "Administrer konto",
    UPGRADE: "Oppgrader",
    LEARN_MORE: "Lær mer...",
    USAGE_UNDER_LIMIT: "Du bruker ${0}% \n av gratisplanen din.",
    USAGE_OVER_LIMIT: "Du er over \n gratiskontogrensen.",
    PLAN_TITLE: "(${0}-plan)",
  },
  ANNOUNCEMENTS_DIALOG: {
    TITLE: "Kunngjøringer",
    OK: "OK",
    REMIND_ME_LATER: "Minn meg på det senere",
  },
  WORKSPACE_CARD: {
    HIDDEN_WORKSPACE: "Skjult arbeidsområde",
    TEMPLATE: "Hoylu-mal",
    MORE_OPTIONS: "Flere alternativer",
    NOT_YET: "Aldri",
    OPEN: "Åpne",
    UNTITLED: "Uten tittel",
    WORKSPACE_MODIFIED: "Arbeidsområde endret siden siste besøk-indikator",
    WORKSPACE_PREVIEW: "forhåndsvisning av arbeidsområde",
    WORKSPACE_IMG_ALT: "Standard miniatyrbilde for arbeidsområde",
    CHANGES_SINCE: "Endringer siden ditt siste besøk",
    NO_CHANGES_SINCE: "Ingen endringer siden ditt siste besøk",
    INACTIVE_PROJECT_LABEL:
      "Dette prosjektet er inaktivt.\nKlikk for mer informasjon.",
    LIMITED_WORKSPACE_LABEL:
      "Grensen for gratiskonto er overskredet.\nIngen nye elementer kan legges til dette arbeidsområdet.\nKlikk for mer informasjon.",
    LIMITED_TITLE: "Begrenset",
    DELETE: "Slett",
    DELETE_WORKSPACE: "Slett arbeidsområde",
    ASSIGN_PROJECT: "Tildel til prosjekt",
    REMOVE_PROJECT: "Fjern fra prosjekt",
    DUPLICATE: "Dupliser",
    ADD_LABEL: "Etikett",
    LABELS: "Etiketter",
    DUPLICATE_WORKSPACE: "Dupliser arbeidsområde",
    LEAVE: "Forlat",
    LEAVE_WORKSPACE: "Forlat arbeidsområde",
    HIDE: "Skjul",
    HIDE_WORKSPACE: "Skjul arbeidsområde",
    UNHIDE: "Vis",
    UNHIDE_WORKSPACE: "Vis arbeidsområde",
    ICON: "ikon",
    SHARE: "Del",
    SHARE_SETTINGS: "Delingsinnstillinger",
    EDIT_TITLE: "Rediger tittel",
    DOWNLOAD_ARCHIVE: "Last ned arkiv",
    WORKSPACE_INFO: "Arbeidsområdeinformasjon",
    EDIT_TEMPLATE: "Rediger mal",
    EDIT_TEMPLATE_TOOLTIP:
      "Rediger malarbeidsområde. Vær oppmerksom på at andre kan opprette duplikater av malen mens du redigerer hvis de har tilgang til arbeidsområdet.",
    LOADED: "Lastet",
  },
  WORKSPACE_PASSWORD: {
    ADD_PASSWORD: "Legg til passord",
    ADD_WORKSPACE_PASSWORD: "Legg til arbeidsområdepassord:",
    CANCEL: "Avbryt",
    CHANGE: "Endre",
    CHANGE_PASSWORD: "Endre passord",
    CHANGE_WORKSPACE_PASSWORD: "Endre arbeidsområdepassord",
    CHARACTERS: "(minst 8 tegn)",
    CONFIRM_NEW_PASSWORD: "Bekreft arbeidsområdepassord",
    ENTER_CURRENT_PASSWORD: "Angi nåværende passord",
    REMOVE: "Fjern",
    REMOVE_PASSWORD: "Fjern passord",
    REMOVE_WORKSPACE_PASSWORD: "Fjern arbeidsområdepassord",
    SET_NEW_PASSWORD: "Angi arbeidsområdepassord",
    WORKSPACE_NO_PASSWORD: "Ingen passord angitt",
    WORKSPACE_PASSWORD_SET: "Arbeidsområdepassord er angitt",
  },
  WORKSPACE_PERMISSIONS: {
    ADD_USERS: "Legg til brukere",
    ADD_USERS_TO_PROJECT: "Add Users to Project",
    ADD_WITH_ACCESS: "Legg til med ${0}-tilgang",
    CANCEL: "Avbryt",
    NOTIFY_USERS: "Varsle brukere via e-post",
    USER_PERMISSION: "Brukertillatelse vil være",
    BY_POLICY_ANY_ORG_ADMIN: "Etter policy enhver org-admin", // By policy any org admin [has] [Admin, Write, Read, No] [access]
    PROJECT_ADMINS: "Prosjektadministrator", // Project admin [has] [Admin, Write, Read, No] [access]
    ENTER_USER: "Angi bruker",
    NO_RESULTS_FOUND: "Ingen resultater funnet",
    USE_THIS_ADDRESS: "Bruk denne adressen",
    SUGGESTED_USERS: "Foreslåtte brukere",
    LOADING: "Laster...",
    FAILED_TO_LOAD_USERS: "Kunne ikke laste brukere.",
    NO_ACCOUNTS_ERROR: "Det finnes ingen Hoylu-kontoer for e-posten(e):",
    INVITE_AND_ADD: "Inviter til Hoylu",
    FIELDS: {
      EMAIL: "e-post",
      NAME: "brukernavn",
      PERMISSION: "tillatelse",
    },
    SORT: {
      BY_X: "Sorter etter ${0}",
      BY_X_ASC: "Sorter etter ${0} (stigende)",
      BY_X_DSC: "Sorter etter ${0} (synkende)",
    },
  },
  WORKSPACE_TEMPLATES: {
    CREATE: "opprett",
    PREVIEW: "forhåndsvis",
    AGILE: "Agil",
    DESIGN: "Design",
    IDEATION: "Idéutvikling",
    BUSINESS: "Business",
    TEMPLATES: "Maler",
  },
  AGILE_PLANNING: {
    PRESET: "Velg forhåndsinnstilling",
  },
  DOWNLOAD_DIALOG: {
    DOWNLOAD: "Last ned",
    PASSWORD: "Passord",
    SHOW_PASSWORD: "Vis passord",
    CANCEL: "Avbryt",
    DOWNLOADING: "Laster ned...",
    DOWNLOAD_FAILED: "Nedlasting mislyktes.",
    DOWNLOAD_FAILED_403: "Nedlasting mislyktes, sjekk passordet.",
    TIMESTAMP_LABEL: "Tidsstempel - din lokale tid (valgfritt)",
    TIMESTAMP_TOOLTIP:
      "Velg et tidsstempel for å laste ned arbeidsområdet slik det var på det tidspunktet. La stå tomt for å laste ned nåværende tilstand.",
  },
  UPLOAD_DIALOG: {
    UPLOADING_WORKSPACE: "Laster opp arbeidsområde",
    LOADED: "lastet",
    PROCESS: "behandlet",
    STEP: "Trinn",
    BROWSE: "Bla gjennom",
    ERROR: "Kunne ikke laste opp arbeidsområde",
  },
  INSIGHTS_DIALOG: {
    CLOSE: "Lukk",
    OPEN_IN_NEW_WINDOW: "Åpne Insights i nytt vindu",
  },
  THUMBNAIL_EDITOR: {
    TITLE: "Arbeidsområdeminiatyrbilde",
    CANCEL: "Avbryt",
    SAVE: "Lagre",
    DELETE: "Slett",
    GENERATE_THUMBNAIL: "Generer miniatyrbilde",
    TAKE_SNAPSHOT: "Ta øyeblikksbilde",
    TYPE: "Type",
    CUSTOM_IMAGE: "Egendefinert bilde",
    SNAPSHOT: "Øyeblikksbilde",
    BROWSE: "Bla gjennom",
    ERR: "Kun *.png, *.jpg og *.gif med opptil 1MB størrelse støttes",
  },
  MANAGE_ACCOUNT: {
    TITLE: "Administrer konto",
    EMAIL: "E-post",
    CREATED: "Konto opprettet den: ",
    DELETE: "Slett konto",
    CLOSE: "Lukk",
    MANAGE: "Administrer",
  },
  CONFIRM_ACCOUNT_DELETE: {
    TITLE: "Slett konto: ",
    P1: "For å slette kontoen din:",
    POINT1: "Kryss av i bekreftelsesavkrysningsboksen og",
    POINT2: 'Klikk deretter "Slett konto".',
    P2: "Du vil motta en e-post som bekrefter at Hoylu har mottatt forespørselen din og en oppfølgings-e-post med ytterligere informasjon.\nHoylu vil fortsette med å slette kontoen din permanent om 7 dager.",
    CONFIRM: "Bekreft at slettede kontoer ikke kan gjenopprettes",
    DELETE: "Slett konto",
    CANCEL: "Avbryt",
  },
  SECTIONS: {
    HIDDEN: "Skjult",
    FAVORITES: "Siste favoritter",
    PROJECT: {
      COLLABORATORS: "Prosjektsamarbeidspartnere",
      PROJECT_SETTINGS: "Prosjektinnstillinger",
      COPY_LINK: "Kopier lenke til prosjekt",
      DASHBOARD: "Prosjekt dashboard",
      PROJECT_INSIGHTS: "Åpne innsikt",
      REPORT_TYPE: "Rapporttype",
      DELETE_SCOPE: "Slett alle prosjektdata",
      RELOAD: "Last inn på nytt",
    },
    START_FROM_TEMPLATE: {
      TITLE: "Velkommen, ${0}!",
      BUTTON: "Bla gjennom maler",
      LABEL: "Start fra mal",
    },
    WORKSPACES_LIST: "Arbeidsområdeliste",
  },
  HEADER: {
    NO_ACCESS:
      "Tilgang til prosjekt nektet. Vennligst kontakt prosjektadministratoren",
  },
  VALIDATION: {
    MANDATORY_FIELD: "Dette feltet er påkrevd",
    CHARACTER_LIMIT: "Tittelen er for lang",
  },
  PROJECT: {
    DURATION: "${0} dager",
    REMAINING_DURATION: "Gjenværende prosjektvarighet: ${0} dager",
  },
  HELP_MENU: {
    TOOLTIP: "Hjelp og ressurser",
    ANNOUNCEMENTS: {
      TITLE: "Kunngjøringer",
      TOOLTIP: "Nyheter og kunngjøringer fra Hoylu",
      URL: "https://www.hoylu.com/blog/announcements/",
    },
    GET_STARTED: {
      TITLE: "Kom i gang",
      TOOLTIP: "Åpne lenke for å komme i gang med Hoylu i en ny fane",
      URL: "https://www.hoylu.com/get-started/",
    },
    TUTORIALS: {
      TITLE: "Veiledninger",
      TOOLTIP: "Åpne lenke for å se veiledninger i en ny fane",
      URL: "https://www.hoylu.com/videos/",
    },
    KNOWLEDGE_BASE: {
      TITLE: "Kunnskapsbase",
      TOOLTIP: "Åpne lenke for å se kunnskapsbase i en ny fane",
      URL: "https://support.hoylu.com",
    },
    PRODUCT_FEEDBACK: {
      TITLE: "Produkttilbakemelding",
      TOOLTIP: "Åpne lenke for å gi produkttilbakemelding i en ny fane",
      URL: "https://support.hoylu.com/hc/en-us/requests/new",
    },
  },
  ZENDESK_WIDGET: {
    TITLE: "Trenger du hjelp? Spør om Hoylu her.",
    ARIA_LABEL: "Veksle Hoylu-støttewidget",
  },
};
